import React, {useState} from 'react'
import {Swiper, SwiperSlide, useSwiper} from 'swiper/react'
import {Grid, Navigation, Pagination} from 'swiper'
import 'swiper/css/pagination'
import 'swiper/css/grid'
import Balancer from 'react-wrap-balancer'
import './personal.css'

import people1 from '../../../../images/relocation/people_1.png'
import people2 from '../../../../images/relocation/people_2.png'
import people3 from '../../../../images/relocation/people_3.jpg'
import people4 from '../../../../images/relocation/people_4.png'
import people5 from '../../../../images/relocation/people_5.png'

import styles from './styles.module.scss'

const PersonalGenerium = () => {
  const [swiper, setSwiper] = useState(null);
  const [indexSwiperElem, setIndexSwiperElem] = useState(0)

  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <div>
            <p className={styles.title}>Честные отзывы</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
            <p className={styles.title}>Сотрудники о Generium</p>
          </div>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.left}>
          <div className={styles.preview_people}>
            {indexSwiperElem !== 0 ? (
              <>
                <div onClick={() => swiper.slideTo(0)}>
                  <img className='preview_people-slider-photo' src={people1} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 1 ? (
              <>
                <div onClick={() => swiper.slideTo(1)}>
                  <img className='preview_people-slider-photo' src={people2} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 2 ? (
              <>
                <div onClick={() => swiper.slideTo(2)}>
                  <img className='preview_people-slider-photo' src={people3} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 3 ? (
              <>
                <div onClick={() => swiper.slideTo(3)}>
                  <img className='preview_people-slider-photo' src={people5} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 4 ? (
              <>
                <div onClick={() => swiper.slideTo(4)}>
                  <img className='preview_people-slider-photo' src={people4} alt='people' draggable='false'/>
                </div>
              </>

            ) : ''}
          </div>
          <div className={styles.preview_people_active}>
            {indexSwiperElem == 0 ? (
              <><img className='preview_people_active-slider-photo' src={people1} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 1 ? (
              <><img className='preview_people_active-slider-photo' src={people2} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 2 ? (
              <><img className='preview_people_active-slider-photo' src={people3} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 3 ? (
              <><img className='preview_people_active-slider-photo' src={people5} alt='people' draggable='false'/></>
              ) : ''}
            {indexSwiperElem == 4 ? (
              <><img className='preview_people_active-slider-photo' src={people4} alt='people' draggable='false'/></>
            ) : ''}
          </div>
        </div>
        <div className={styles.right}>
          <p className={styles.text2}>
            <Balancer ratio={0.50}>
              {indexSwiperElem === 0
                  ? 'Решение о переезде далось нашей семье не сразу. Мы с супругой долго обсуждали этот момент, взвешивая все за и против, но всё же сделали ставку на перспективное развитие моей карьеры в области прикладной науки. В итоге нам тут очень понравилось. Меня привлекло то, что здесь красивая, ухоженная территория, с удачно проработанным ландшафтным дизайном, развитой инфраструктурой. Жить и работать в окружении природы – это здорово!'
                  + '\n\n' +
                  'Нам предоставили комфортное жилье, у нас просто прекрасные соседи, а когда выдается время, мы ходим в бассейн, играем в настольный теннис и посещаем занятия по английскому языку.'

                  : indexSwiperElem === 1
                  ? 'Я решилась на переезд, потому что мне нравится идея жить в тихом и красивом месте. К тому же в академгородке есть вся необходимая инфраструктура. Здесь очень уютно, чисто и безопасно.'
                  + '\n\n' +
                  'В свободное время я гуляю с собакой, хожу в походы и каждую неделю посещаю клуб настольных игр. А в выходные ко мне приезжают друзья из города. Мы устраиваем пикники, организуем конные походы в местном клубе и участвуем в сплавах на байдарках.'

                  : indexSwiperElem === 2
                  ? 'Я решилась на переезд, потому что это уникальное, на мой взгляд, место работы, поражающее воображение. Помимо того, что  Generium – ведущая российская биотехнологическая компания, это еще и целый городок с фитнес-центром, бассейном, ухоженной территорией,  рестораном, жильем для сотрудников.'
                  + '\n\n' +
                  'Хочется особенно отметить, что здесь всё сделано для людей. Компания внимательна к своим сотрудникам, создает достойные условия, учитывает пожелания. В Вольгинском живут очень доброжелательные и отзывчивые люди. Думаю, это потому, что многие сотрудники переехали сюда ради работы, оставив где-то свой дом. Люди стараются поддерживать друг друга. Чувствуется теплая семейная атмосфера!'

                  : indexSwiperElem === 3
                  ? 'Я пришел в Generium из академической науки и работаю в компании со дня основания ее R&D-центра в 2011 г. За это время я не просто получил здесь неоценимый опыт, но и по-другому стал смотреть на биомедицину в целом. '
                  + '\n\n' +
                  'Для сотрудника, ранее не работавшего в подобных компаниях, Generium открывает двери в удивительный, интересный мир фармацевтической индустрии. Человек, имеющий руки и голову, способный обучаться, обладающий рабочей этикой и дисциплиной, безусловно, найдет здесь свой путь к успеху и сможет достичь в компании многого.'
                  : indexSwiperElem === 4
                  ? 'Если меня спросят: «Что для тебя означает «комфорт»?», я отвечу, что это жизнь на Барском Лугу, не задумываясь. Здесь можно навсегда забыть слова «пробка», «давка», «час пик в метро». Ведь, чтобы добраться до работы, мне требуется всего 5 минут. Комфортно? Не то слово!'
                  + '\n\n' +
                  'Продуктивно поработав, у меня всегда остается достаточно свободного времени на саморазвитие, хобби, посещение бассейна и душевные вечера с песнями под гитару. Я очень благодарна декану факультета фундаментальной медицины МГУ имени М. В. Ломоносова, рассказавшему мне еще на втором курсе про это удивительное место в поселке Вольгинском. Такой комфорт невозможно променять на что-то другое, ведь именно здесь моя душа интроверта и ценителя природы поет и раскрывается.'
                : null}

            </Balancer>
          </p>
          <div className="slider_main_mod_pg">
            <Swiper
              spaceBetween={70}
              slidesPerView={1}
              navigation
              onSlideChange={swiper => setIndexSwiperElem(swiper.activeIndex)}
              pagination={{
                type: 'fraction'
              }}
              onSwiper={setSwiper}
              modules={[Pagination, Navigation]}
              breakpoints={{
              // 1537: {
              //   spaceBetween: 70,
              //   slidesPerView: 1
              // },
              // 1536: {
              //   spaceBetween: 70,
              //   slidesPerView: 4
              // },
              // 1440: {
              //   spaceBetween: 70,
              //   slidesPerView: 3.9
              // },
              // 1365: {
              //   spaceBetween: 70,
              //   slidesPerView: 3.6
              // },
              // 1025: {
              //   spaceBetween: 55,
              //   slidesPerView: 3.2
              // },
              // 769: {
              //   spaceBetween: 50,
              //   slidesPerView: 3
              // },
              640: {
                slidesPerView: 1,
                initialSlide: 0
              },
              480: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              },
              370: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              },
              320: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              }
               }}
            >
              <SwiperSlide id='0' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people1} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Решение о переезде далось нашей семье не сразу. Мы с супругой долго обсуждали этот момент, взвешивая все за и против, но всё же сделали ставку на перспективное развитие моей карьеры в области прикладной науки. В итоге нам тут очень понравилось. Меня привлекло то, что здесь красивая, ухоженная территория, с удачно проработанным ландшафтным дизайном, развитой инфраструктурой. Жить и работать в окружении природы – это здорово!</p>
                    <p className={styles.text}>Нам предоставили комфортное жилье, у нас просто прекрасные соседи, а когда выдается время, мы ходим в бассейн, играем в настольный теннис и посещаем на занятия по английскому языку.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide id='1' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people2} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я решилась на переезд, потому что мне нравится идея жить в тихом и красивом месте. К тому же в академгородке есть вся необходимая инфраструктура. Здесь очень уютно, чисто и безопасно.</p>
                    <p className={styles.text}>В свободное время я гуляю с собакой, хожу в походы и каждую неделю посещаю клуб настольных игр. А в выходные ко мне приезжают друзья из города. Мы устраиваем пикники, организуем конные походы в местном клубе и участвуем в сплавах на байдарках.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='2' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people3} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я решилась на переезд, потому что это уникальное, на мой взгляд, место работы, поражающее воображение. Помимо того, что  Generium – ведущая российская биотехнологическая компания, это еще и целый городок с фитнес-центром, бассейном, ухоженной территорией,  рестораном, жильем для сотрудников.</p>
                    <p className={styles.text}>Хочется особенно отметить, что здесь всё сделано для людей. Компания внимательна к своим сотрудникам, создает достойные условия, учитывает пожелания. В Вольгинском живут очень доброжелательные и отзывчивые люди. Думаю, это потому, что многие сотрудники переехали сюда ради работы, оставив где-то свой дом. Люди стараются поддерживать друг друга. Чувствуется теплая семейная атмосфера!</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='3' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people5} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я пришел в Generium из академической науки и работаю в компании со дня основания ее R&D-центра в 2011 г. За это время я не просто получил здесь неоценимый опыт, но и по-другому стал смотреть на биомедицину в целом.</p>
                    <p className={styles.text}>Для сотрудника, ранее не работавшего в подобных компаниях, Generium открывает двери в удивительный, интересный мир фармацевтической индустрии. Человек, имеющий руки и голову, способный обучаться, обладающий рабочей этикой и дисциплиной, безусловно, найдет здесь свой путь к успеху и сможет достичь в компании многого.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='4' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people4} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Если меня спросят: «Что для тебя означает «комфорт»?», я отвечу, что это жизнь на Барском Лугу, не задумываясь. Здесь можно навсегда забыть слова «пробка», «давка», «час пик в метро». Ведь, чтобы добраться до работы, мне требуется всего 5 минут. Комфортно? Не то слово!</p>
                    <p className={styles.text}>Продуктивно поработав, у меня всегда остается достаточно свободного времени на саморазвитие, хобби, посещение бассейна и душевные вечера с песнями под гитару. Я очень благодарна декану факультета фундаментальной медицины МГУ имени М. В. Ломоносова, рассказавшему мне еще на втором курсе про это удивительное место в поселке Вольгинском. Такой комфорт невозможно променять на что-то другое, ведь именно здесь моя душа интроверта и ценителя природы поет и раскрывается.</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <p className={styles.text_b}>
            {indexSwiperElem === 0 ? (
              <>
                <p>Степан</p>
                <p>Старший технолог</p>
              </>
            ) : indexSwiperElem === 1 ? (
              <>
                <p>Елена</p>
                <p>Технолог участка</p>
              </>
            ) : indexSwiperElem === 2 ? (
              <>
                <p>Алина</p>
                <p>Младший научный сотрудник</p>
              </>
            ) : indexSwiperElem === 3 ? (
              <>
                <p>Дмитрий</p>
                <p>Советник по науке</p>
              </>
            ) : indexSwiperElem === 4 ? (
              <>
                <p>Алина</p>
                <p>Научный сотрудник</p>
              </>
            ) : (
              <>
              <p>Степан</p>
              <p>Старший технолог участка биосинтеза</p>
            </>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default PersonalGenerium
